import { render, staticRenderFns } from "./WhitelistBlacklist.vue?vue&type=template&id=6e7b23da"
import script from "./WhitelistBlacklist.vue?vue&type=script&lang=js"
export * from "./WhitelistBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports